import { useEffect } from "react";

export const INTRO_SPLIT_DELAY_MS = 1050;
const INTRO_SPLIT_DURATION_MS = 1700;
const INTRO_WORD_FADE_MS = 760;
const INTRO_POST_SPLIT_BUFFER_MS = 200;
const INTRO_ANIMATION_LEAD_MS = 220;
const INTRO_ANIMATIONS_START_MS = Math.max(INTRO_SPLIT_DELAY_MS - INTRO_ANIMATION_LEAD_MS, 0);
const INTRO_TOTAL_MS = INTRO_SPLIT_DELAY_MS + INTRO_SPLIT_DURATION_MS + INTRO_POST_SPLIT_BUFFER_MS;
const INTRO_LOGO_SRC = "/new%20logo%20ROSKAM.png";

export default function IntroReveal({ active, onSplitStart, onComplete }) {
  useEffect(() => {
    if (!active) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      const reducedSplitTimer = window.setTimeout(() => {
        onSplitStart?.();
      }, 40);
      const reducedTimer = window.setTimeout(() => {
        onComplete?.();
      }, 120);
      return () => {
        window.clearTimeout(reducedSplitTimer);
        window.clearTimeout(reducedTimer);
      };
    }

    const splitTimer = window.setTimeout(() => {
      onSplitStart?.();
    }, INTRO_ANIMATIONS_START_MS);

    const timer = window.setTimeout(() => {
      onComplete?.();
    }, INTRO_TOTAL_MS);

    return () => {
      window.clearTimeout(splitTimer);
      window.clearTimeout(timer);
    };
  }, [active, onSplitStart, onComplete]);

  if (!active) return null;

  return (
    <div
      className="intro-reveal"
      aria-hidden="true"
      style={{
        "--intro-split-delay": `${INTRO_SPLIT_DELAY_MS}ms`,
        "--intro-split-duration": `${INTRO_SPLIT_DURATION_MS}ms`,
        "--intro-word-fade-duration": `${INTRO_WORD_FADE_MS}ms`
      }}
    >
      <div className="intro-reveal__panel intro-reveal__panel--top">
        <img src={INTRO_LOGO_SRC} alt="" className="intro-reveal__logo" />
      </div>
      <div className="intro-reveal__panel intro-reveal__panel--bottom">
        <img src={INTRO_LOGO_SRC} alt="" className="intro-reveal__logo" />
      </div>
    </div>
  );
}
